var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, } from "vue-property-decorator";
import ModalBase from "../../components/modalbase.vue";
let DeletionForm = class DeletionForm extends Vue {
    submit() { }
    cancel() { }
};
__decorate([
    Prop({ required: true })
], DeletionForm.prototype, "selection", void 0);
__decorate([
    Inject()
], DeletionForm.prototype, "i18n", void 0);
__decorate([
    Emit()
], DeletionForm.prototype, "submit", null);
__decorate([
    Emit()
], DeletionForm.prototype, "cancel", null);
DeletionForm = __decorate([
    Component({
        components: {
            ModalBase,
        },
        name: "DeletionForm",
    })
], DeletionForm);
export default DeletionForm;
